import { toast } from "sonner";
import { trackWhatsApp, trackPhoneView, sendBackendEvent } from "../analytics";

// Format TZS
export const formatTZS = (amount) => `TZS ${Number(amount || 0).toLocaleString("en-TZ")}`;

export const whatsappUrl = (phone) => {
  let number = String(phone || "").replace(/\D/g, "");
  if (number.startsWith("00")) number = number.slice(2);
  if (number.startsWith("0")) number = `255${number.slice(1)}`;
  return `https://wa.me/${number}?text=${encodeURIComponent("Habari, nimeona hoteli yenu kwenye Habari Stays. Ningependa kujua upatikanaji wa chumba [date range]. Mnaweza kunisaidia?")}`;
};

// Display metadata for the amenity names stored on hotels. Unknown amenities
// fall back to a check mark and their stored name.
const AMENITY_META = {
  WiFi: ["📶", "WiFi"],
  Parking: ["🅿️", "Parking"],
  AC: ["❄️", "AC"],
  "A/C": ["❄️", "AC"],
  Restaurant: ["🍽️", "Restaurant"],
  Pool: ["🏊", "Pool"],
  Security: ["🔒", "Security"],
  Breakfast: ["🍳", "Breakfast"],
  "Hot Water": ["🚿", "Hot water"],
  Bar: ["🍺", "Bar"],
};
export const amenityMeta = (name) => {
  const [icon, label] = AMENITY_META[name] || ["✓", name];
  return { icon, label };
};

// Directory preferences stay on this device and are scoped to the signed-in user.
const preferenceKey = (kind) => {
  let id = "guest";
  try { id = JSON.parse(localStorage.getItem("user"))?.id || id; } catch {}
  return `hs_${kind}_${id}`;
};
export const readHotels = (kind) => {
  try { const value = JSON.parse(localStorage.getItem(preferenceKey(kind)) || "[]"); return Array.isArray(value) ? value : []; } catch { return []; }
};
export const storeHotels = (kind, hotels) => {
  try { localStorage.setItem(preferenceKey(kind), JSON.stringify(hotels)); window.dispatchEvent(new Event("hotel-preferences")); }
  catch { toast.error("Unable to save hotels on this device"); }
};
export const rememberHotel = (hotel) => storeHotels("recent", [hotel, ...readHotels("recent").filter(h => h.id !== hotel.id)].slice(0, 20));

// Contact clicks are tracked in GA and in the backend analytics events.
export const trackWhatsAppClick = (hotel) => { trackWhatsApp(hotel.id, hotel.name, hotel.city); void sendBackendEvent("whatsapp_click", {hotel_id: hotel.id, city: hotel.city}); };
export const trackCallClick = (hotel) => { trackPhoneView(hotel.id, hotel.name, hotel.city); void sendBackendEvent("phone_revealed", {hotel_id: hotel.id, city: hotel.city}); };
